import React, {useCallback, useMemo, useState} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Ebay from "../../component/quick-list/Ebay";
import ToQuickList from "../../component/quick-list/ToQuickList";
import QuickListed from "../../component/quick-list/QuickListed";

import {useGetQuickListList} from "../../hooks/useQuickList";
import {useNavigate} from "react-router-dom";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import CustomDateRangeInput from "../../component/CustomDateRangeInput";

const QuickList = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [dateRange, setDateRange] = useState(() => {
        const today = moment().startOf('day').toDate();
        return [today, today];
    });

    const [startDate, endDate] = dateRange;

    const handleCalendarChange = useCallback(
        (dates) => {
            setDateRange(dates);
        },
        []
    );

    const setDateRangePreset = (preset) => {
        let start, end;
        const today = moment().startOf('day');

        switch (preset) {
            case 'last7':
                start = today.clone().subtract(6, 'days').toDate();
                end = today.clone().endOf('day').toDate();
                break;
            case 'thisMonth':
                start = today.clone().startOf('month').toDate();
                end = today.clone().endOf('month').toDate();
                break;
            case 'today':
            default:
                start = today.clone().toDate();
                end = today.clone().toDate();
                break;
        }
        setDateRange([start, end]);
    };

    const startDateString = useMemo(() => (startDate ? moment(startDate).format("YYYY-MM-DD") : ""), [startDate]);
    const endDateString = useMemo(() => (endDate ? moment(endDate).format("YYYY-MM-DD") : ""), [endDate]);
    const handleNavigateBack = useCallback(() => navigate(-1), [navigate]);


    const {data: allScreenList, isLoading: isScreeningLoading} =
        useGetQuickListList({
            limit: 100,
            startDate: startDateString,
            endDate: endDateString
        });


    return (
        <>
            <Container fluid className="p-4">
                <Row className="mb-4 justify-content-between align-items-center">
                    <Col xs="auto">
                        <i
                            onClick={handleNavigateBack}
                            className="fa-solid fa-arrow-left"
                            style={{cursor: "pointer", color: "white", fontSize: "1.5rem"}}
                        />
                    </Col>
                    <Col xs="auto" className="d-flex align-items-center">
                        <div className="date-controls">
                            <DatePicker
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                onChange={handleCalendarChange}
                                isClearable={false}
                                dateFormat="yyyy-MM-dd"
                                customInput={<CustomDateRangeInput startDate={startDate} endDate={endDate}/>}
                            />
                            <div>
                                <button type="button" className="quick-range-btn"
                                        onClick={() => setDateRangePreset('today')}>Today
                                </button>
                                <button type="button" className="quick-range-btn"
                                        onClick={() => setDateRangePreset('last7')}>Last 7 Days
                                </button>
                                <button type="button" className="quick-range-btn"
                                        onClick={() => setDateRangePreset('thisMonth')}>This Month
                                </button>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row lg={12}>
                    <Col lg={3}>
                        <Ebay
                            totalFreightCount={allScreenList?.totalFreightCount || 0}
                            totalGroundCount={allScreenList?.totalGroundCount || 0}
                            isScreeningLoading={isScreeningLoading}
                        />
                    </Col>
                    <Col lg={6}>
                        <ToQuickList
                            currentPage={currentPage}
                            startDate={startDate}
                            endDate={endDate}
                            setCurrentPage={setCurrentPage}
                            allScreenList={allScreenList}
                            isScreeningLoading={isScreeningLoading}
                        />
                    </Col>
                    <Col lg={3}>
                        <QuickListed
                            dailyAverage={allScreenList?.dailyAverage || 0}
                            weeklyAverage={allScreenList?.weeklyAverage || 0}
                            monthlyAverage={allScreenList?.monthlyAverage || 0}
                            isScreeningLoading={isScreeningLoading}
                        />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default QuickList;
